import axios from 'axios';
import { isAuthToken } from '../survey-ui/services/authToken';

export function attachApiSession(config) {
    const token = localStorage.getItem('token_id');
    try {
        const apiOrigin = new URL(process.env.REACT_APP_NODE_API_URL).origin;
        const requestUrl = new URL(config.url, config.baseURL || process.env.REACT_APP_NODE_API_URL);
        if (requestUrl.origin === apiOrigin && isAuthToken(token)) {
            config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
        }
    } catch (_) {
        // Leave invalid URLs to Axios without attaching credentials.
    }
    return config;
}

// Covers direct Axios calls as well as the shared API helpers.
axios.interceptors.request.use(attachApiSession);
